import React, { useEffect } from "react";
import PropTypes from "prop-types";
import CarDeliveryTemplate from "../../sections/car-delivery-template";
import useAccountLogin from "../../hooks/useAccountLogin";
import { useSelector } from "react-redux";
import { selectUserState } from "../../selectors/application";
import LoginForm from "../../sections/login-form";
import { useHistory } from "react-router-dom";

const CarDeliveryLogin = ({ fields }) => {

  const { loginForm, backgroundImage, nextUrl } = fields
  const { loginFailed, loginWrongEmailOrPassword, loginNetworkError, loginAccountLock, temporaryLock, login } = useAccountLogin();
  /** Redux Start*/
  const user = useSelector(selectUserState);
  /** Redux End */
  const history = useHistory()  

  const submitLogin = async (evt, data) => {
    const { userInfo } = await login(data.email, data.password);
    if (userInfo) {
      history.push(nextUrl.value.href)
    }
  };

  useEffect(() => {
    if(user !== null){

      history.push(nextUrl.value.href)
    }
  }, []);

  return (
    <section className="car-delivery-login">
      <CarDeliveryTemplate fields={fields} backgroundImage={backgroundImage}>
        <LoginForm 
        {...{...loginForm[0]?.fields,
            loginFailed,
            loginNetworkError,
            loginAccountLock,
            temporaryLock, 
            loginWrongEmailOrPassword,
            submitLogin: (evt, data) => submitLogin(evt, data) 
        }} />
      </CarDeliveryTemplate>
    </section>
  );
};

CarDeliveryLogin.propTypes = {
  loginForm: PropTypes.object,
  backgroundImage: PropTypes.object,
};

export default CarDeliveryLogin;
